import axios from 'axios';
import {
    LOAD_CITIES,
    LOGIN,
    LOAD_MODEL,
    POST_DATA,
    POST_DATA_MENU,
    SEARCH_COTIZACION,
    INFO_USER,
    UPDATE_INFO_USER,
    ALERT_DATA,
    LOADING,
    ERROR_BACK,
    SET_WAITING_CITIES
} from './types';
import { isNotProductive, strToDate, verifyData } from './../utilities';
import useLoading from '../hooks/useLoading';

// Colores pastel
const colors = [
    'rgba(255, 179, 186, 0.8)',  // Light Pink
    'rgba(255, 205, 210, 0.8)',  // Soft Red
    'rgba(178, 223, 219, 0.8)',  // Pastel Teal
    'rgba(255, 235, 159, 0.8)',  // Light Yellow
    'rgba(204, 255, 204, 0.8)',  // Mint Green
    'rgba(174, 214, 241, 0.8)',  // Light Sky Blue
    'rgba(230, 190, 255, 0.8)',  // Lavender
    'rgba(255, 223, 186, 0.8)',  // Soft Peach
    'rgba(255, 255, 186, 0.8)',  // Light Lemon
    'rgba(186, 255, 201, 0.8)',  // Light Green
    'rgba(186, 225, 255, 0.8)',  // Baby Blue
    'rgba(255, 186, 255, 0.8)',  // Soft Purple
    'rgba(255, 203, 186, 0.8)',  // Coral
    'rgba(255, 204, 255, 0.8)',  // Rose Pink
    'rgba(229, 204, 255, 0.8)'   // Soft Violet
];

const dir = window.location.href
export let url = isNotProductive ? process.env.REACT_APP_CUSTOM_TEST_URL : process.env.REACT_APP_CUSTOM_URL;
export let urladmin = isNotProductive ? process.env.REACT_APP_ADMIN_TEST_URL : process.env.REACT_APP_ADMIN_URL;
export const urllog = process.env.REACT_APP_LOG;
export const options = { headers: { "Content-Type": "application/x-www-form-urlencoded" } };
export const params = new URLSearchParams();

export function credentials({ user, password, token, test }) {
    const usr = null;
    const date = null;
    const pwd = null;
    params.set('usuario', usr?.trim()?.replace("_test", "") || user?.trim()?.replace("_test", ""));
    params.set('clave', pwd || password || '');
    params.set('token', token || '');
    params.set('test', /*dir.includes('/dev') ||*/ test || token?.startsWith("!"));
    params.set('hash', date === new Date().toLocaleDateString());
}

export function logIn(data) {
    return function (dispatch) {
        //{  ...data, user: usr || data.user}
        credentials(data);
        if (data.token) {
            params.set('nomlcia', data.city || '');
            params.set('nomprv', data.provincia || '');
            params.set('url', dir || '');
        }
        params.set("opcpm", "");
        axios.post(url, params, options)
            .then(r => {
                if (!r.data.error) {
                    let codProvincia;
                    const products = [];
                    const consultaProductos = [];
                    const provinces = [];
                    const cities = [];
                    const menu = [];
                    const countries = [];
                    const brand = [];
                    const activities = [];
                    const vendors = [];
                    const sucursales = [];
                    const regions = [];
                    const zones = [];
                    const optState = [];
                    const sections = [];
                    const sinistersSections = [];
                    const companies = [];
                    const causes = [];
                    const coverages = [];
                    const sinistersStates = [];
                    const relationship = [];
                    const optTypeUser = [];
                    const ciaPol = [];
                    const empresas = [];
                    const cards = [];
                    let mawdy = {};
                    const dataPayment = {
                        arrPayMethod: [],
                        payMethodMoto: [],
                        rel: [],
                    };

                    r.data.provincias?.forEach(item => {
                        provinces.push({ value: item.codprv, label: item.nomprv });
                    });

                    r.data.menu?.forEach(item => {
                        products.push({
                            plan: item.nompro,
                            label: item.nompro,
                            price: item.impcot.toFixed(2),
                            details: item.despro.includes("\n") ? item.despro.split("\n") : item.despro.split("!"),
                            section: parseInt(item.codsec),
                            codpro: item.codpro,
                            value: item.codpro,
                        });
                        menu.push({
                            codsec: parseInt(item.codsec),
                            nomsec: item.nomsec,
                            codcia: item.codcia,
                            hasdes: item.hasdes,
                            porpde: item.porpde,
                            msgpde: item.msgpde,
                        });
                    });
                    r.data.conpro?.forEach(item => {
                        consultaProductos.push({
                            plan: item.nompro,
                            label: item.nompro,
                            price: item.impcot.toFixed(2),
                            details: item.despro.includes("\n") ? item.despro.split("\n") : item.despro.split("!"),
                            section: parseInt(item.codsec),
                            codpro: item.codpro,
                            value: item.codpro,
                            letraPlan: item.plapro,
                        });
                    });

                   /* if (r.data.empresa.codemp === 4 || r.data.empresa.codemp === 54) {
                        products.sort((a, b) => {
                            if (a.label < b.label) return -1;
                            if (a.label > b.label) return 1;
                            return 0;
                        });
                    } else {*/
                    products?.sort((a, b) => a.price - b.price);
                   // }
                    /* 
                        El ordenamiento funciona para que deje los precios 0 al principio
                        así, el componente Table usará el índice para mostrar los precios
                        de las motos con la columna correspondiente
                    */

                    r.data.paises?.forEach((item) => {
                        countries.push({
                            value: item.codpai,
                            label: item.nompai,
                        });
                    });

                    r.data.marcas?.forEach((item) => {
                        brand.push({
                            value: item.codmar,
                            label: item.desmar,
                        });
                    });

                    r.data.formasdepago?.forEach((item) => {
                        dataPayment.arrPayMethod.push({
                            value: item.codpag,
                            label: item.nompag,
                            codpro: item.codpro,
                            id: item.idpag,
                            codsec: item.codsec,
                        });
                    });

                    r.data.actividades?.forEach((item) => {
                        activities.push({
                            value: item.codact,
                            label: item.nomact,
                            codcia: item.codcia,
                        });
                    });

                    r.data.usuarios?.forEach((vendedor) => {
                        let suc = r.data.sucursales?.find(suc => suc.codsuc === vendedor['cod-suc']);
                        let reg = r.data.regiones?.find(reg => reg.codreg === Number(suc?.codreg));
                        vendedor['ape-usu'] && vendors.push({
                            ...vendedor,
                            value: vendedor['ven-usu'],
                            label: vendedor['ape-usu'],
                            sucursal: vendedor['cod-suc']?.toString(),
                            region: reg?.codreg?.toString(),
                            zona: reg?.codzon?.toString(),
                            'cod-suc': vendedor['cod-suc']?.toString(),
                        });
                    });

                    r.data.sucursales?.forEach((sucursal) => {
                        sucursales.push({ value: sucursal.codsuc.toString(), label: sucursal.nomsuc, codreg: sucursal.codreg });
                    });

                    r.data.regiones?.forEach((region) => {
                        regions.push({ value: region.codreg.toString(), label: region.nomreg, codzon: region.codzon });
                    });

                    r.data.zonas?.forEach((zona) => {
                        zones.push({ value: zona.codzon.toString(), label: zona.nomzon });
                    });

                    r.data.estados?.forEach((estado) => {
                        optState.push({ value: estado.codpme, label: estado.despme });
                    })

                    r.data.secciones?.forEach((seccion, ix) => {
                        if (seccion.sinsec)
                            sinistersSections.push({ value: seccion.codsec, label: seccion.nomsec });
                        if (seccion.consec)
                            sections.push({ value: seccion.codsec, label: seccion.nomsec, color: colors[ix] });
                    });

                    r.data.companias?.forEach(compania => {
                        companies.push({ value: compania.codcia, label: compania.nomcia });
                    });

                    r.data.coberturas?.forEach(cobertura => {
                        coverages.push({ value: cobertura.codcob, label: cobertura.descob });
                    });

                    r.data.causas?.forEach(causa => {
                        causes.push({ value: causa.codcau, label: causa.descau });
                    });

                    r.data.estadosSiniestros?.forEach(estado => {
                        sinistersStates.push({ value: estado.codpes, label: estado.despes });
                    });

                    r.data.parentescos?.forEach(parentesco => {
                        relationship.push({ value: parentesco.codpmp, label: parentesco.despmp });
                    });

                    r.data.niveles?.forEach(nivel => {
                        nivel.codpca < 10 && optTypeUser.push({ value: nivel.codpca, label: nivel.despca });
                    })

                    r.data.ciaPol?.forEach(pol => {
                        ciaPol.push({ ...pol, value: pol['pol-pcp'], label: pol['pol-pcp'] });
                    })

                    r.data.empresas?.forEach(emp => {
                        empresas.push({ value: emp['cod-emp'], label: emp['nom-emp'] });
                    })

                    r.data.tarjetas?.forEach(tarjeta => {
                        cards.push({ ...tarjeta, 'cod-sec': Number(tarjeta['cod-sec']), value: tarjeta['cod-tar'], label: tarjeta['nom-tar'] });
                    })
                    if (r.data.mawdy) {
                        mawdy = {
                            ...mawdy,
                            pdv: r.data.mawdy?.split("-")?.[0],
                            token: r.data.mawdy?.split("-")?.[1],
                            comercio: r.data.mawdy?.split("-")?.[2],
                            idCarpeta: r.data.mawdy?.split("-")?.[3],
                            errCode: r.data.mawdy?.split("-")?.[4]
                        };
                    };

                    if (data.provincia) codProvincia = provinces.find((provincia) => provincia.label === data.provincia)?.value;
                    if (data.token) r.data.ciudades?.length > 1 && r.data.ciudades.map((item) => cities.push({ value: item.codloc, label: item.nomloc, codprv: item.codprv }));
                    const payload = {
                        activities,
                        arrPayMethod: dataPayment?.arrPayMethod,
                        brand,
                        cards,
                        causes,
                        ciaPol,
                        cities,
                        city: data.city || '',
                        codemp: r.data.empresa?.codemp,
                        codProvincia,
                        companies,
                        countries,
                        coverages,
                        data,
                        empresas,
                        error: false,
                        infoCompany: r.data?.empresa,
                        menu,
                        nameCompany: r.data?.empresa.abremp,
                        opcEnabled: r.data.opciones,
                        optState,
                        optTypeUser,
                        payMethodMoto: dataPayment?.payMethodMoto,
                        products,
                        consultaProductos,
                        provinces,
                        regions,
                        relationship,
                        sections,
                        availableSections: r.data.availableSections || [],
                        sinistersSections,
                        sinistersStates,
                        sucursales,
                        token: data?.token,
                        vendors,
                        zones,
                        mawdy,
                        // codpos: data?.codpos,
                        user: {
                            habilitado: r.data.habilitado,
                            nro: data?.nro, // nro de intención de venta
                            email: r.data?.nomusu,
                            legajo: r.data?.legajo,
                            sucursal: r.data?.nomsuc,
                            vendor: r.data?.venusu,
                            password: data?.password || '',
                            name: r.data?.nombre,
                            address: r.data?.direccion,
                            sex: r.data?.sexo,
                            login: true,
                            id: r.data?.codusu,
                            isAdmin: r.data?.codpca === 10,
                            level: Number(r.data?.codpca),
                            opcusu: r.data?.opcusu,
                            test: data.test || r.data.test,
                            grupo: data.grupo || '',
                        },
                    };
                    dispatch({ type: LOGIN, payload });
                    params.set('url', '')
                } else {
                    const payload = {
                        logeado: false,
                        error: true,
                        msgError: r.data.error || 'Error',
                    }
                    dispatch({ type: LOGIN, payload });
                }
            })
            .catch((err) => {
                params.set("opcpm", "505")
                params.set("error", err)
                params.set("url", dir)
                axios.post(url, params, options)
                dispatch({
                    type: LOGIN, payload: {
                        logeado: false,
                        error: true,
                        msgError: "Error 505",
                    }
                });
            });
    };
};

// export const searchCities = async (provinceCode, codcia, nomlcia, dispatch) => {
//     dispatch({ type: LOADING, payload: true });
//     try {
//         params.set('opcpm', "localidades");
//         params.set('codcia', codcia);
//         params.set('codprv', provinceCode);
//         nomlcia && params.set('nomlcia', nomlcia);
//         const r = await axios.post(url, params, options);
//         const cities = [];
//         r.data.forEach(item => {
//             const exist = cities.find(p => p.label.startsWith(item.nomloc));
//             if (!exist)
//                 cities.push({
//                     codprv: item.codprv,
//                     value: item.codloc,
//                     label: item.nomloc,
//                 })
//         });
//         dispatch({ type: LOAD_CITIES, payload: { cities, nomlcia } });
//         dispatch({ type: LOADING, payload: false });
//     } catch (error) {
//         dispatch({ type: LOAD_CITIES, payload: { cities: [], nomlcia: '' } });
//     };
// };

export function searchCities(provinceCode, codcia, nomlcia) {
    return async function (dispatch) {
        // dispatch({ type: LOAD_CITIES, payload: { cities: [], nomlcia } });
        params.set('opcpm', "localidades");
        params.set('codcia', codcia);
        params.set('codprv', provinceCode);
        nomlcia && params.set('nomlcia', nomlcia);
        dispatch({type: SET_WAITING_CITIES, payload: true});
        await axios.post(url, params, options)
            .then(r => {
                const cities = [];
                r.data.forEach(item => {
                    const exist = cities.find(p => p.label.startsWith(item.nomloc));
                    if (!exist)
                        cities.push({
                            codprv: item.codprv,
                            value: item.codloc,
                            label: item.nomloc,
                        })
                });
                dispatch({ type: LOAD_CITIES, payload: { cities, nomlcia } });
            })
            .catch(() => {
                dispatch({ type: LOAD_CITIES, payload: { cities: [], nomlcia: '' } });
            })
            .finally(() =>  dispatch({type: SET_WAITING_CITIES, payload: false}));
    };
};

export function searchCotizacion() {
    return function (dispatch) {
        dispatch({ type: SEARCH_COTIZACION, payload: [] })
        params.set('opcpm', "tarjetas");
        axios.post(url, params, options)
            .then(r => {
                const payload = [];
                r.data.forEach(item => {
                    payload.push({
                        value: item.codtar,
                        label: item.nomtar,
                    })
                })
                dispatch({ type: SEARCH_COTIZACION, payload })
            })
            .catch(() => {
                dispatch({ type: SEARCH_COTIZACION, payload: [] })
            })
    }
}

export function searchModels(brand, ano) {
    return function (dispatch) {
        dispatch({ type: LOAD_MODEL, payload: { models: [], assured: [], loading: true } });
        params.set('opcpm', "modelos");
        params.set('codmar', brand);
        params.set('codano', ano);
        axios.post(url, params, options)
            .then(r => {
                // console.log(r.data)
                const models = [];
                const assured = [];
                r.data.forEach(item => {
                    models.push({
                        value: item.codmod,
                        label: item.nommod,
                    });
                    assured.push({
                        value: item.codmod,
                        label: item.valmod < 30000 ? item.valmod * 1000 : item.valmod,
                    });
                });
                const payload = { models, assured, loading: false };
                dispatch({ type: LOAD_MODEL, payload });
            })
            .catch(() => {
                dispatch({ type: LOAD_MODEL, payload: { models: [], assured: [], loading: false } });
            })
    };
};

// ------------------------------ Profile Data ------------------------------ //

export function updateInfoUser(data) {
    return function (dispatch) {
        dispatch({ type: UPDATE_INFO_USER, payload: [] })
        params.set('opcpm', "editInfoUser");
        params.set('address', data.address);
        axios.post(url, params, options)
            .then(r => {
                //console.log(r)
                dispatch({ type: UPDATE_INFO_USER })
            });
    }
}

export function getInfoUser() {
    return function (dispatch) {
        params.set('opcpm', "UserInfo")
        axios.post(url, params, options)
            .then(r => {
                //console.log(r.data)
                dispatch({ type: INFO_USER, payload: r.data })
            })
    }
}

// ------------------------------ Save Data ------------------------------ //

export function saveMenu(data, company, recid) {
    const { nro, dni, email, birthday, city, codcia, vendor, codsec, codusu } = data;
    const menuData = { nro, dni, email, birthday, city, codcia, vendor, codsec, codusu, company };
    const step = 'Menu';
    const { status, error, properties, borrado, client } = verifyData(menuData, step);
    if (!error && !borrado) {
        return function (dispatch) {
            params.set('opcpm', "Menu");
            params.set('codpmpol', recid || '');
            params.set('ninpol', data.nro || 0);
            params.set('codemp', company);
            params.set('codsec', data.codsec);
            params.set('dnipol', data.dni);
            params.set('emapol', data.email);
            params.set('nompol', data.name || '');
            params.set('apepol', data.lastname || '');
            params.set('nacpol', strToDate(data.birthday));
            params.set('codloc', data.city);
            params.set('venusu', data.vendor);
            params.set('codusu', data.codusu);
            /* -- Dato Mawdy -- */
            params.set('cotmaw', (data.codsec === 27 && 'MAW') || '');
            params.set('prvpol', (data.codsec === 27 && data.province) || '');
            params.set('cpopol', (data.codsec === 27 && data.postalcode) || '');
            /* -- Datos Moto -- */
            params.set('codpag', data.payMethod || '');
            params.set('modpol', data.model || '');
            params.set('anopol', data.year || '');
            params.set('marpol', data.brand || '');
            params.set('sexpol', data.genre || '');
            params.set('codcia', data.codcia || '');
            params.set('facpol', data.facpol || '');
            /*Dato subempresa*/
            params.set('subemp', data.grupo || '');
            //params.set('codpos', )
            /**/
            params.set('cityDescripcion', data.cityDescripcion || '');
            if (data.token) {
                params.set('nompol', data.name || '');
                params.set('apepol', data.lastname || '');
                params.set('sexpol', data.genre || '');
                params.set('dompol', data.address || '');
                params.set('telpol', data.phone || '');
                params.set('arepol', data.area || '');
                params.set('codpai', data.nationality || '');
            }
            axios.post(url, params, options)
                .then(r => {
                    let loading = false;
                    params.set('modpol', '');
                    params.set('cotmaw', '');
                    if (r.data.cotizacion) {
                        dispatch({ type: SEARCH_COTIZACION, payload: { ...r.data, loading } });
                    } else {
                        dispatch({ type: POST_DATA_MENU, payload: r.data });
                    }
                })
                .catch(r => {
                    dispatch({ type: POST_DATA, payload: null });
                });
        }
    } if (error) {
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties } });
        }
    }
    else if (borrado) {
        //Esta sentencia detecta si hubo un error en el desarrollo o si se borraron props.
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties, client } });
        }
    };
};

export function saveTitularData(data, recid) {
    const step = 'TitularData';
    const { name, lastname, address, phone, province, city, genre, activity, expose, nationality, } = data;
    const titularData = { name, lastname, address, phone, province, city, genre, activity, expose, nationality };
    const { status, error, properties, borrado, client } = verifyData(titularData, step, recid);
    // console.log({data})
    if (!error && !borrado) {
        return async function (dispatch) {
            params.set('opcpm', "TitularData");
            params.set('codpmpol', recid);
            params.set('nompol', data.name);
            params.set('cuipol', data.cuil);
            params.set('numpol', data.numAddress);
            params.set('dompol', data.address);
            params.set('ecapol', data.between);
            params.set('apepol', data.lastname);
            params.set('sexpol', data.genre);
            params.set('cpopol', data.postalcode);
            params.set('arepol', data.area);
            params.set('telpol', data.phone); //Se dejó este campo para que se pueda actualizar el teléfono
            // params.set('telpol', data.celular || data.phone); //Ver con empresa 34 por error en actualizacion de celular
            params.set('codact', data.activity);
            params.set('exppol', data.expose);
            params.set('codpai', data.nationality);
            params.set('codpro', data.codpro);
            params.set('codloc', data.city);
            params.set('prepol', data.price);
            params.set('codcia', data.codcia);
            params.set('sumpol', data.sumAssured ? data.sumAssured : '')
            params.set('emapol', data.email || '')
            await axios.post(url, params, options)
                .then(r => {
                    console.log('respuesta: ', r.data)
                    if (r.data.error.descripcion == "") { 
                        dispatch({ type: POST_DATA, payload: r.data.codpmpol });
                    } else {     
                        dispatch({ type: ERROR_BACK, payload: r.data.error.descripcion });
                    }
                })
                .catch(r => {
                    dispatch({ type: POST_DATA, payload: null });
                });
        };
    } if (error) {
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties } });
        };
    }
    else if (borrado) {
        // "Esta sentencia detecta si hubo un error en el desarrollo o si se borraron props.");
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties, client } });
        }
    };
}


export function saveHomeData(data, recid) {
    //console.log(data, recid)
    const step = "HomeData";
    const { address, homeType, city, province } = data;
    const homeData = { address, homeType, city, province };
    const { status, error, properties, borrado, client } = verifyData(homeData, step, recid);

    if (!error && !borrado) {
        return function (dispatch) {
            params.set('opcpm', "HomeData");
            params.set('codpmpol', recid);
            params.set('idomloc', data.address);
            params.set('codviv', data.homeType);
            params.set('icodloc', data.city);
            params.set('mtspol', data.squareMeters);
            axios.post(url, params, options)
                .then(r => {
                    //console.log('respuesta: ', r.data)
                    dispatch({ type: POST_DATA, payload: r.data.codpmpol });
                })
                .catch(r => {
                    dispatch({ type: POST_DATA, payload: null });
                });
        };
    } if (error) {
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties } });
        };
    } else if (borrado) {
        //"Esta sentencia detecta si hubo un error en el desarrollo o si se borraron props.");
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties, client } });
        }
    };
}

export function saveVehicleData(data, recid) {
    const step = "VehicleData";
    const { motor, chassis, isNew } = data;
    const vehicleData = { motor, chassis, isNew };
    const { status, error, properties, borrado, client } = verifyData({ ...vehicleData, company: data.company }, step, recid);

    if (!error && !borrado) {
        return async function (dispatch) {
            params.set('opcpm', "VehicleData");
            params.set('codpmpol', recid);
            params.set('ckmpol', data.isNew);
            params.set('patpol', data.patent);
            params.set('motpol', data.motor);
            params.set('chapol', data.chassis);
            params.set('usopol', data.use === '' ? 'P' : data.use);
            await axios.post(url, params, options)
                .then(r => {
                    //  console.log('respuesta: ', r.data)
                    dispatch({ type: POST_DATA, payload: r.data.codpmpol });
                    if (typeof (r.data.error) === 'string') {
                        dispatch({ type: ALERT_DATA, payload: { codpmpol: r.data.codpmpol, status: r.data.error, error: r.data.error } });
                    }
                    else {
                        dispatch({ type: ALERT_DATA, payload: { codpmpol: r.data.codpmpol, status: r.data.codpmpol, error: '' } });
                    }
                })
                .catch(r => {
                    dispatch({ type: POST_DATA, payload: null });
                });
        };
    } if (error) {
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties } });
        };
    } else if (borrado) {
        //"Esta sentencia detecta si hubo un error en el desarrollo o si se borraron props.
        return function (dispatch) {
            dispatch({ type: ALERT_DATA, payload: { status, error, properties, client } });
        }
    };
}

export function saveTecnologyData(data, recid) {
    return function (dispatch) {
        //console.log(data, recid)
        params.set('opcpm', "TecnologyData");
        params.set('codpmpol', recid);
        params.set('naspol', data.name);
        params.set('aaspol', data.lastname);
        params.set('faspol', data.birthdate);
        params.set('daspol', data.dni);
        params.set('modpol', data.modelo);
        params.set('marpol', data.marca);
        axios.post(url, params, options)
            .then(r => {
                //console.log('respuesta: ', r.data)
                dispatch({ type: POST_DATA, payload: r.data.codpmpol });
                dispatch({ type: LOADING, payload: false });
            })
            .catch(r => {
                dispatch({ type: POST_DATA, payload: null });
                dispatch({ type: LOADING, payload: false });
            });
    };
};


export function savePayMethod(data, recid) {
    const step = "PayMethod"
    const { payMethod, creditCard, cardNumber, fullName, dni, expires, encryptedNumber, tarjetaPlana } = data;
    const payment = { payMethod, creditCard, cardNumber, fullName, dni, expires, encryptedNumber };
    const { status, error, properties } = verifyData(payment, step, recid);
    //console.log(error)
    // if (!error) {
    return function (dispatch) {
        params.set('opcpm', "PayMethod");
        params.set('codpmpol', recid);
        params.set('codpag', data.payMethod);
        params.set('codtar', data.creditCard);
        params.set('tnumpol', data.cardNumber.replaceAll(" ", ""));
        params.set('ul4pol', data.lastNumbers);
        params.set('tnompol', data.fullName);
        params.set('tdnipol', data.dni);
        params.set('tvtopol', data.expires);
        params.set('prepol', data.price);
        params.set('tarnumpgp', encryptedNumber);
        params.set('tarjetaPlana', tarjetaPlana);
        axios.post(url, params, options)
            .then(r => {
                //console.log('respuesta: ', r.data)
                dispatch({ type: POST_DATA, payload: r.data.codpmpol });
            })
            .catch(r => {
                dispatch({ type: POST_DATA, payload: null });
            });
    };
}


export function saveBeneficiary(legal, data, recid, lastBen) {
    return function (dispatch) {
        params.set('opcpm', "BeneficiaryData");
        params.set('codpmpol', recid);
        params.set('blepol', legal);
        data && params.set('pmben', JSON.stringify(data));
        params.set('lastBen', lastBen);
        axios.post(url, params, options)
            .then(r => {
                //console.log('respuesta: ', r.data)
                dispatch({ type: POST_DATA, payload: r.data.codpmpol });
            })
            .catch(r => {
                dispatch({ type: POST_DATA, payload: null });
            });
    }
}

export function cancelPol(recid) {
    return function (dispatch) {
        params.set('opcpm', "cancelPol");
        params.set('codpmpol', recid);
        axios.post(url, params, options)
            .then(r => {
                //console.log('respuesta: ', r.data)
                dispatch({ type: POST_DATA, payload: r.data.codpmpol });
            })
            .catch(r => {
                dispatch({ type: POST_DATA, payload: null });
            });
    }
}

export async function validatePlan(recid, plan) {

    params.set('opcpm', "validatePlan");
    params.set('codpmpol', recid);
    params.set('plan', plan.codpro || plan.value);
    try {
        const response = await axios.post(url, params, options);
        if(!response.data.valid) {
            return false;
        }
        return true;
    } catch (error) {
        return false;
    }

}